export const buildClickAlternativeProductTags = (eventName: string, productId: string) => ({
  event: eventName,
  ecommerce: { product_id: productId },
});
